export default function () {
  document.addEventListener('DOMContentLoaded', function() {
    const setupBackgroundHeight = (headerSelector, backgroundSelector, offsets) => {
      const header = document.querySelector(headerSelector);
      const background = document.querySelector(backgroundSelector);

      if (!header || !background) return;

      const setHeight = () => {
        const headerHeight = header.offsetHeight + offsets.reduce((sum, offset) => sum + offset, 0);
        background.style.height = `${headerHeight}px`;
      };

      setHeight();
      window.addEventListener('resize', setHeight);

      return setHeight;
    };

    const background = document.querySelector('.product-new__background');
    const awardsContainer = document.querySelector('.awards.awards_top0.black-mode');
    const awardsItems = awardsContainer ? awardsContainer.querySelectorAll('.awards__item') : [];
    const isLogin = background ? background.getAttribute('data-login') : false;
    let mobileOffsets;
    let desktopOffsets;


    if (isLogin) {
      desktopOffsets = [84, 82, 100, 80];
    } else {
      desktopOffsets = [84, 82, 100];
    }

    if (awardsItems.length > 0) {
        mobileOffsets = [58, 68, 130];
    } else {
        mobileOffsets = [58, 68, 57];
    }

    const desktopResizeHandler = setupBackgroundHeight(
      '.product-new-header',
      '.product-new__background',
      desktopOffsets
    );

    const mobileResizeHandler = setupBackgroundHeight(
      '.product-new-header',
      '.product-new__background-mobile',
      mobileOffsets
    );

    return {
      cleanup: () => {
        window.removeEventListener('resize', desktopResizeHandler);
        window.removeEventListener('resize', mobileResizeHandler);
      }
    };
  });
}
